import React from 'react';

const About = () => {
  return (
    <div className="about2-main-wrapper float_left">
      <div className="container">
        <div className="row">
          <div className="col-lg-4 d-none d-xl-block d-lg-block">
            <img src="images/about2-img.jpg" alt="About" className="w-100" />
          </div>
          <div className="col-lg-8 col-md-12 col-12">
            <div className="sb-about-section">
              <h3>
                About <span>Us</span>
              </h3>
              <h4>
                We Care For Your Health. Provide Best
                Medical Treatment.
              </h4>
              <p>
                It is a long established fact that a reader will be distracted by the readable established
                fact that content of a page when looking at its layout. The point of using Lorem Ipsum established
                fact that a reader. The point of using Lorem Ipsum.
              </p>
              <div className="counter-main">
                <div className="count-up">
                  <div className="counter-icon">
                    <i className="fas fa-smile-beam"></i>
                  </div>
                  <div>
                    <h4 className="counter-count">4500</h4>
                    <p>Happy Patients</p>
                  </div>
                </div>
                <div className="count-up">
                  <div className="counter-icon">
                    <i className="fas fa-award"></i>
                  </div>
                  <div>
                    <h4 className="counter-count">500</h4>
                    <p>Award win</p>
                  </div>
                </div>
                <div className="count-up">
                  <div className="counter-icon">
                    <i className="fas fa-hospital"></i>
                  </div>
                  <div>
                    <h4 className="counter-count">250</h4>
                    <p>Hospital Rooms</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
